import Module from './DocumentCart';

export default Module;
